import { _ as __rest, a as __assign } from './tslib.es6-01f7d394.js';
import { c as classNames } from './index-8a7d9ef9.js';
import * as React from 'react';
import { s as skeletonStyles } from './skeleton.module-e159ab57.js';

var styles = {"container":"IndicatorPill_container_b142f9a0","label":"IndicatorPill_label_b142f9a0","withLeftIcon":"IndicatorPill_withLeftIcon_b142f9a0","skeleton":"IndicatorPill_skeleton_b142f9a0"};

var IndicatorPill = React.forwardRef(function IndicatorPill(props, ref) {
    var _a, _b;
    var className = props.className, label = props.label, color = props.color, isSkeleton = props.isSkeleton, leftIcon = props.leftIcon, otherProps = __rest(props, ["className", "label", "color", "isSkeleton", "leftIcon"]);
    return (React.createElement("div", __assign({ ref: ref, "aria-busy": isSkeleton, className: classNames(styles.container, (_a = {},
            _a[skeletonStyles.skeleton] = isSkeleton,
            _a[styles.skeleton] = isSkeleton,
            _a), className), style: { color: isSkeleton ? undefined : color } }, otherProps),
        React.createElement("div", { className: classNames(styles.label, (_b = {},
                _b[styles.withLeftIcon] = leftIcon,
                _b)) },
            leftIcon,
            React.createElement("span", null, label))));
});

export { IndicatorPill as I };
